import React, { FC } from 'react';

import { TEXTS } from 'application/pages/BillingPage/renderer/texts';
import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';
import { toast } from '@shared/ui';
import { useAccountCompanyId } from 'application/hooks';
import { refreshAccountData } from '@entities/account';
import { useAppDispatch } from '@shared/store';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import useRemoveCard from '@entities/paymentMethod/api/useRemoveCard';

import styles from './CardRemoveModal.module.scss';

const CardRemoveModal: FC<ModalProps[ModalTypes.BILLING_REMOVE_CARD]> = ({ close, afterClose }) => {
  const companyId = useAccountCompanyId();
  const dispatch = useAppDispatch();

  const { request: removeCard, result: removeCardResult } = useRemoveCard();

  const removeCardSubmit = async () => {
    try {
      const isOk = await removeCard(companyId);

      if (isOk) {
        toast.info(TEXTS.BILLING_REMOVE_CARD_NOTIFICATION_MESSAGE);
        await dispatch(refreshAccountData(companyId));
        close();
        afterClose?.();
      }
    } catch (e) {
      toast.error(TEXTS.BILLING_REMOVE_CARD_NOTIFICATION_ERROR_MESSAGE);
    }
  };

  return (
    <ModalScreen
      title={TEXTS.BILLING_REMOVE_CARD_MODAL_TITLE}
      titlePlacement="left"
      hideCloseButton
      onClose={close}
      actionButtons={[
        <Button
          key="button_confirm_remove_card_modal"
          elementId="button_confirm_remove_card_modal"
          isLoading={removeCardResult.loading}
          type={ButtonType.PRIMARY}
          onClick={removeCardSubmit}>
          {TEXTS.BILLING_REMOVE_CARD_MODAL_CONFIRM}
        </Button>,
        <Button
          key="button_cancel_remove_card_modal"
          elementId="button_cancel_remove_card_modal"
          type={ButtonType.SECONDARY}
          isLoading={removeCardResult.loading}
          onClick={() => close()}>
          {TEXTS.BILLING_BIND_CARD_MODAL_CANCEL}
        </Button>,
      ]}>
      <div className={styles.CardRemoveModalDesc}>{TEXTS.BILLING_REMOVE_CARD_MODAL_DESCRIPTION}</div>
    </ModalScreen>
  );
};

export default CardRemoveModal;
